module.exports = __webpack_public_path__ + "img/DE03948.6c33605e.png";